import Vue from 'vue'
import Vuex from 'vuex'
import apps from '@/store/apps'
import appsBar from '@/store/appsBar'
import importRecord from '@/store/importRecord'
import newReportDialog from '@/store/newReportDialog'
import snackBar from '@/store/snackBar'
import viewRecord from '@/store/viewRecord'
import deleteDialog from '@/store/deleteDialog'
import editDialog from '@/store/editDialog'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    apps,
    appsBar,
    deleteDialog,
    editDialog,
    importRecord,
    newReportDialog,
    snackBar,
    viewRecord
  }
})
